import { render, staticRenderFns } from "./GK40Heizungsprofi.vue?vue&type=template&id=702fedbc&lang=pug&"
import script from "./GK40Heizungsprofi.vue?vue&type=script&lang=ts&"
export * from "./GK40Heizungsprofi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports